import { render } from "./RequestFormPage.vue?vue&type=template&id=08583eea"
import script from "./RequestFormPage.vue?vue&type=script&lang=js"
export * from "./RequestFormPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__